'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  padding: 0;\n\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  padding: 0;\n\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  background-color: ', ';\n  border: none;\n  cursor: pointer;\n  &:focus {\n    outline: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n'], ['\n  width: ', ';\n  height: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  background-color: ', ';\n  border: none;\n  cursor: pointer;\n  &:focus {\n    outline: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: ', ';\n  border: none;\n  font-size: ', ';\n  text-align: center;\n  height: ', ';\n  color: ', ';\n  background-color: ', ';\n  border: ', ' solid ', ';\n  font-family: ', ';\n  outline: 0;\n  &:focus {\n    outline: 0;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n  }\n'], ['\n  width: ', ';\n  border: none;\n  font-size: ', ';\n  text-align: center;\n  height: ', ';\n  color: ', ';\n  background-color: ', ';\n  border: ', ' solid ', ';\n  font-family: ', ';\n  outline: 0;\n  &:focus {\n    outline: 0;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.span(_templateObject);

var Button = _styledComponents2.default.button(_templateObject2, (0, _polished.rem)(32), (0, _polished.rem)(32), (0, _polished.rem)(10), (0, _polished.rem)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.color.primaryBg;
});

var Input = _styledComponents2.default.input(_templateObject3, (0, _polished.rem)(32), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font.fontSizeXS;
}, (0, _polished.rem)(32), function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.textColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primaryBg;
}, (0, _polished.rem)(1), function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.separatorColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.font.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.form.placeholderColor;
});

function SignNumberInput(props) {
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      Button,
      { left: true, onClick: function onClick() {
          return props.handleOnDecrease();
        } },
      _react2.default.createElement(_Icon2.default, { size: 's', name: props.iconDec })
    ),
    _react2.default.createElement(Input, {
      type: 'number',
      value: props.value,
      onChange: function onChange(e) {
        return props.handleOnChange(e.target.value);
      },
      iconDecc: props.iconDec,
      iconInc: props.iconInc
    }),
    _react2.default.createElement(
      Button,
      { onClick: function onClick() {
          return props.handelOnIncrease();
        } },
      _react2.default.createElement(_Icon2.default, { size: 's', name: props.iconInc })
    )
  );
}

SignNumberInput.propTypes = {
  handleOnChange: _propTypes2.default.func.isRequired,
  handelOnIncrease: _propTypes2.default.func.isRequired,
  handleOnDecrease: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.number.isRequired,
  iconDec: _propTypes2.default.string,
  iconInc: _propTypes2.default.string
};

SignNumberInput.defaultProps = {
  iconDec: '-',
  iconInc: '+'
};

exports.default = SignNumberInput;
SignNumberInput.__docgenInfo = [{
  'description': '',
  'displayName': 'SignNumberInput',
  'methods': [],
  'props': {
    'handleOnChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'handelOnIncrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'handleOnDecrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'value': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    },
    'iconDec': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'-\'',
        'computed': false
      }
    },
    'iconInc': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'+\'',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/SignNumberInput/index.js'] = {
    name: 'SignNumberInput',
    docgenInfo: SignNumberInput.__docgenInfo,
    path: 'src/SignNumberInput/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/SignNumberInput/index.js
// module id = 324
// module chunks = 1